// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"9424176d","297":"480ab15b","643":"982eb968","787":"362812b1"}[chunkId] + ".chunk.js";
};